import { Modal, Tabs, TabsProps } from 'antd';
import React , {useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setPOMappingModalIsOpen } from '../../store/reducers/orderDashboardSlice';
import MapPOContainer from '../MapPOContainer/mapPOContainer';
import MappedPOContainer from '../MappedPOContainer/mappedPOContainer';

const PoMappingModal = (props:any) => {
    const dispatch = useDispatch();
    const orderDashboardData = useSelector((state: any) => state.orderDashboard);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedWorkOrder, setSelectedWorkOrder] = useState<any>({});
    const [activetab,setactiveTab]=React.useState<string>('1');

    useEffect(() => {
        setIsModalOpen(orderDashboardData.poMappingModal.isModalOpen);
        setSelectedWorkOrder(orderDashboardData.poMappingModal.selectedWorkOrder);
    },[orderDashboardData.poMappingModal.isModalOpen]);
    
    const items: TabsProps['items'] = [
        {
          key: '1',
          label: 'Map A Purchase Order',
          children: <MapPOContainer selectedWorkOrder={selectedWorkOrder} isModalOpen={isModalOpen} activeTab={activetab} onPOMappingSuccess={props.onPOMappingSuccess}/>,
        },
        {
          key: '2',
          label: 'Mapped POs',
          children: <MappedPOContainer selectedWorkOrder={selectedWorkOrder} isModalOpen={isModalOpen} activeTab={activetab} onPOUnmappingSuccess={props.onPOUnmappingSuccess} />
          // <BulkPOForm  activeTab={activetab}/>
          ,
        },
    ];

  return (
    <Modal 
      title="" 
      open={isModalOpen} 
      // onOk={handlemapmodel} 
      onCancel={()=>{
        dispatch(setPOMappingModalIsOpen({isModalOpen:false,selectedWorkOrder:{}}));
        props.handleRefreshWorkOrderTable()
      }} 
      width={1300} 
      footer={null}
      styles={{
        content: {
          borderRadius: '0',
          borderTop: '4px solid #1677ff',
          font: 'normal normal normal 14px/20px Nunito Sans',
        },
      }}>
        <Tabs defaultActiveKey="1" activeKey={activetab} items={items} onChange={(_key:string)=>setactiveTab(_key)} />
      </Modal>
  )
}

export default PoMappingModal;